export const QUERY_CITIC_RISK_MONITORING_START = 'QUERY_CITIC_RISK_MONITORING_START';
export const QUERY_CITIC_RISK_MONITORING_SUCCESS = 'QUERY_CITIC_RISK_MONITORING_SUCCESS';
export const QUERY_CITIC_RISK_MONITORING_FAILURE = 'QUERY_CITIC_RISK_MONITORING_FAILURE';
export const CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT = 'CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT';
